<template>
  <v-tooltip top
    ><template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs" @click="onClick">
        <highlighted-text
          :value="value"
          :highlights="highlights"
          :class="{ 'secondary--text': link }"
        ></highlighted-text></span></template
    ><span>{{ iri.prefixed }}</span></v-tooltip
  >
</template>

<script>
import HighlightedText from './HighlightedText.vue'

import { Iri } from '@/rec-cache/rec-cache-types'

import humanizeString from 'humanize-string'

export default {
  components: { HighlightedText },
  props: {
    iri: {
      type: Object,
      default: () => {
        return new Iri()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
    humanize: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    link: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    value: function () {
      return this.humanize ? humanizeString(this.iri.short) : this.iri.short
    },
  },
  mounted() {
    // console.log(
    //   'components.iri-value.mounted',
    //   this.iri,
    //   this.highlights,
    //   this.link
    // )
  },
  beforeRouteUpdate: function (to) {
    console.log('components.iri-value.before-route-update', to)
  },
  methods: {
    onClick: function (e) {
      console.log('components.iri-value.on-click', this.link)
      if (this.link) {
        // Stopping event propagation only relevant if a link, hence the .stop event modifier is not feasible in the template.
        e.stopPropagation()
        this.$router.push(`/individual/${encodeURIComponent(this.iri.value)}`)
      }
    },
  },
}
</script>
